import React from "react";
import { ratingIcons } from "./ratingIcons";

export default function RatingHeatmapTimeline({ data = [] }) {
    return (
        <div style={{ fontFamily: "'Inter', sans-serif" }}>

            {/* TIMELINE GRID */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(6, 1fr)",
                    gap: 12
                }}
            >
                {data.map((item) => {
                    const config = ratingIcons[item.rating];
                    const Icon = config?.icon;

                    return (
                        <div
                            key={item.month}
                            title={`${item.month}: ${item.rating}`}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                padding: 10,
                                borderRadius: 0,
                                background: "#f6f1e7"
                            }}
                        >
                            {Icon && (
                                <Icon
                                    style={{
                                        fontSize: 28,
                                        color: config.color
                                    }}
                                />
                            )}

                            <span style={{ marginTop: 6, fontSize: 12, color: "#4a443c" }}>
                                {item.month.slice(0, 3)}
                            </span>
                        </div>
                    );
                })}
            </div>

            {/* LEGEND */}
            <div
                style={{
                    marginTop: 20,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 16
                }}
            >
                {Object.entries(ratingIcons).map(([label, config]) => {
                    const Icon = config.icon;

                    return (
                        <div
                            key={label}
                            style={{ display: "flex", alignItems: "center", gap: 6 }}
                        >
                            <Icon style={{ color: config.color }} />
                            <span style={{ fontSize: 13, color: "#4a443c" }}>{label}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}